<template>
  <div class="cr-box appeal-summary">
    <div class="bg-summary-h">Resumo do recurso</div>
    <div class="bg-summary-k">
      <span>Itens no recurso</span>
      <span class="bg-summary-v">
        {{ summary.items }} em {{ summary.guides }} {{ summary.guides === 1 ? 'guia' : 'guias' }}
      </span>
    </div>
    <div class="bg-summary-k">
      <span>Glosado selecionado</span>
      <span class="bg-summary-v">{{ summary.glossed | currency }}</span>
    </div>
    <div class="bg-summary-k">
      <span>Valor recursado</span>
      <span class="bg-summary-v text-primary">{{ summary.appealed | currency }}</span>
    </div>
    <div class="bg-rbar"><span :style="{ width: `${summary.percent}%` }"></span></div>
    <div class="text-xs text-gray text-right">{{ summary.percent }}% do glosado</div>

    <div class="bg-summary-h">Se acatado integralmente</div>
    <div class="bg-summary-k" v-if="receivable">
      <span>Título {{ receivable.document }}</span>
      <span class="bg-summary-v">
        {{ receivable.value.total | currency }}
        <fa-icon :icon="['fal', 'arrow-right']" class="text-gray"/>
        <span class="text-green">{{ receivableAfter | currency }}</span>
      </span>
    </div>
    <div class="text-xs text-gray bg-summary-note" v-if="receivable">
      receita complementar RECUPERACAO LOTE {{ batchNumber }}/R{{ round }}
      <span class="text-green">+{{ summary.appealed | currency }}</span>
    </div>
    <div class="bg-summary-k" v-for="line in transfers" :key="line.key"
         :class="{ 'bg-summary-paid': line.paid }">
      <span>Repasse {{ line.name }}</span>
      <span class="bg-summary-v text-green">+{{ line.credit | currency }}</span>
    </div>
    <div class="text-xs bg-summary-note" v-if="transfers.length"
         :class="transfers.some((line) => line.paid) ? 'text-amber' : 'text-gray'">
      <template v-if="transfers.some((line) => line.paid)">
        <fa-icon :icon="['fal', 'exclamation-triangle']"/>
          repasse já pago: vira crédito no próximo repasse
      </template>
      <template v-else>repasse aberto: soma no próprio título</template>
    </div>

    <div class="bg-summary-h">Prazo</div>
    <div class="bg-summary-k">
      <span>Envio até</span>
      <deadline-clock :deadline="deadline" :show-hint="false"/>
    </div>

    <div class="bg-summary-h">Pendências</div>
    <div class="bg-note bg-note-red bg-summary-pending c-hand" v-if="pending.length > 0"
         @click="$emit('goto-pending')">
      {{ pending.length }} {{ pending.length === 1 ? 'item' : 'itens' }} {{ pendingText }}
      <fa-icon :icon="['fal', 'arrow-right']"/>
        ir até {{ pending.length === 1 ? 'ele' : 'o primeiro' }}
    </div>
    <div class="bg-note bg-note-green bg-summary-pending" v-else-if="summary.items > 0">
      <fa-icon :icon="['fal', 'check-circle']"/>
      {{ xmlAvailable
        ? 'Pronto para gerar o XML de recurso.'
        : 'Pronto para registrar e enviar pelo portal.' }}
    </div>
    <div class="bg-note bg-note-amber bg-summary-pending" v-else>Adicione ao menos um item.</div>
  </div>
</template>

<script>
import DeadlineClock from './DeadlineClock.vue';

export default {
  components: {
    DeadlineClock,
  },
  props: {
    summary: {
      type: Object,
      required: true,
    },
    receivable: {
      type: Object,
      default: null,
    },
    receivableAfter: {
      type: Number,
      default: 0,
    },
    transfers: {
      type: Array,
      default: () => [],
    },
    deadline: {
      type: Object,
      default: null,
    },
    pending: {
      type: Array,
      default: () => [],
    },
    batchNumber: {
      type: [String, Number],
      default: '',
    },
    round: {
      type: Number,
      default: 1,
    },
    xmlAvailable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pendingText() {
      const kinds = new Set(this.pending.map(entry => entry.kind));
      if (kinds.size === 1 && kinds.has('value')) return 'sem valor válido';
      if (kinds.size === 1 && kinds.has('justification')) return 'sem justificativa';
      return 'com pendência';
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";

.appeal-summary {
  margin-bottom: 0;
  position: sticky;
  top: 0;
  .bg-summary-note { margin: -.1rem 0 .2rem; }
  .bg-summary-pending { margin-bottom: 0; }
}
</style>
